import React, { useEffect, useState, useContext } from "react"
import { Navigate, Outlet, useNavigate, useLocation } from "react-router-dom"
import { HomeOutlined, ContactsOutlined, EditOutlined, ExclamationCircleOutlined, ReadOutlined } from '@ant-design/icons';
import axios from "axios";
import { Avatar, Table, Switch, ConfigProvider, Modal, Button, Menu, Col, Row, message, Space, Checkbox, Carousel } from "antd";
import NewTable from "./components/NewTable";
import Label_language from '../language';
import AdminClassSchedulingModal from "./components/AdminClassScheduleModal";
const label_language = Label_language.ems.children

const AdminClassScheduling = () => {
    const [class_week, set_class_week] = useState([]);
    const [class_date, set_class_date] = useState([]);
    const language = useContext(ConfigProvider.ConfigContext).locale.locale
    const [total, set_total] = useState(1);
    const [extra_columns, set_extra_columns] = useState(null);
    const [search_date, set_search_date] = useState([undefined, undefined])
    const [is_resign, set_is_resign] = useState(false);
    const [loading, set_loading] = useState(0)
    const [force_reload, set_force_reload] = useState(0)
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [title, setTitle] = useState();
    const [edit, setEdit] = useState(false);
    const [open, setOpen] = useState(false);
    const [color, setColor] = useState('d65b77');
    const [editcard, setEditCard] = useState({});
    const [choose_column, set_choose_column] = useState([]);
    const [custom_filter_value, set_custom_filter_value] = useState(null);
    const { confirm } = Modal;
    const [datas, setDatas] = useState([]);
    const [msg, setMsg] = useState(0);
    const [messageApi, contextHolder] = message.useMessage();
    const navigate = useNavigate();
    const [default_column, set_default_column] = useState([
        {
            title: label_language.course_arrangement_management.children.AdminClassScheduling.children.name_serial[language],
            key: 'name_serial',
            dataIndex: 'name_serial',
            align: 'center',
        },
        {
            title: label_language.course_arrangement_management.children.AdminClassScheduling.children.class_name[language],
            key: 'name',
            dataIndex: 'name',
            align: 'center',
        },
        {
            title: label_language.course_arrangement_management.children.AdminClassScheduling.children.lesson_name[language],
            // key: 'lesson_name',
            // dataIndex: 'lesson_name',
            align: 'center',
            render: (text, record, index) => (
                <>
                    {record.lesson_class_data && record.lesson_class_data.map((value, i) => {
                        return (
                            <>
                                {value.lesson_name}
                            </>)
                    })}</>
            ),
        },
        {
            title: label_language.course_arrangement_management.children.AdminClassScheduling.children.lesson_time[language],
            // key: 'name',
            // dataIndex: 'name',
            align: 'center',
            render: (text, record, index) => (
                <>{record.class_time_start_default}-{record.class_time_end_default}</>
            ),
        },
        {
            title: label_language.course_arrangement_management.children.AdminClassScheduling.children.admission_time[language],
            // key: 'name',
            // dataIndex: 'name',
            align: 'center',
            render: (text, record, index) => (
                <>{record.admission_class_time_start_default}-{record.admission_class_time_end_default}</>
            ),
        },
        {
            title: label_language.course_arrangement_management.children.AdminClassScheduling.children.admission_amount[language],
            key: 'upper_limit_people',
            dataIndex: 'upper_limit_people',
            align: 'center',
        },
        {
            title: label_language.course_arrangement_management.children.AdminClassScheduling.children.lesson_date[language],
            // key: 'name',
            // dataIndex: 'name',
            align: 'center',
            render: (text, record, index) => (
                <>{record.weekend_start}-{record.weekend_end}</>
            ),
        },
        {
            title: label_language.course_arrangement_management.children.AdminClassScheduling.children.lesson_teacher[language],
            // key: 'name',
            // dataIndex: 'name',
            align: 'center',
            render: (text, record, index) => (
                <>
                    {record.teacher_data && record.teacher_data.map((value, i) => {
                        return (
                            <>
                                {value.teacher_name}
                            </>)
                    })}
                </>)
        },
        {
            title: label_language.course_arrangement_management.children.AdminClassScheduling.children.class_status[language],
            key: 'enroll_status',
            align: 'center',
            render: (text, record, index) => {
                if (record.enroll_status == true) {
                    return (
                        <>
                            <Switch checked={true} disabled />
                        </>
                    )
                } else {
                    return (
                        <>
                            <Switch checked={false} disabled />
                        </>
                    )
                }
            }
        },
        {
            title: label_language.Common.children.control[language],
            align: 'center',
            sorter: false,
            render: (text, record, index) => (
                <>
                    <Button type="text" style={{ color: 'rgba(43, 193, 123, 1)' }} onClick={e => handleOnEditRow(record)}>{label_language.Common.children.edit[language]}</Button>
                    <Button type="text" style={{ color: 'red' }} onClick={() => showMessage(record.class_id)}>{label_language.Common.children.delete[language]}</Button>
                </>
            )
        },
    ]);
    const showMessage = (value) => {
        confirm({
            title: label_language.Common.children.sure_delete[language],
            icon: <ExclamationCircleOutlined />,
            okText: label_language.Common.children.sure[language],
            okType: 'primary',
            cancelText: label_language.Common.children.cancel[language],
            onOk() {
                handleOnDelete(value);
            },
            centered: true
        });
    };
    const handleOnEditRow = (record) => {
        setTitle(label_language.Common.children.edit[language]);
        setColor('f09a45');
        setEdit(true);
        setOpen(true);
        setEditCard(record)
    }
    const getData = (param, sort, filter, checklist) => {
        // console.log(param);
        set_loading(true);
        set_choose_column(checklist);
        set_custom_filter_value(param?.keyword);
        return axios
            .get('/cramSchool/api/admission_class', {
                params: {
                    cur_page: param?.current,
                    size: param?.pageSize,
                    custom_filter_key: checklist,
                    custom_filter_value: param?.keyword,
                    // employment_time_start: search_date[0],
                    // employment_time_end: search_date[1],  
                    order: sort && Object.entries(sort).map(([map_key, map_value]) => ({ column: map_key, type: map_value }))
                },
                // paramsSerializer: function (params) {
                //     const NewParams = Object.entries(params).map(([map_key, map_value]) => {
                //         if (map_key === 'order') {
                //             return Object.entries(map_value).map(([map_value_key,map_value_value], i) => {
                //                 return `order[${i}][column]=${map_value_key}&order[${i}][type]=${map_value_value}`;
                //             })
                //         }else if (map_key === 'custom_filter_key') {
                //             return map_value.map(map_item=>`custom_filter_key[]=${map_item}`).join("&");
                //         }else{
                //             return `${map_key}=${map_value}`;
                //         }
                //     })
                //     return NewParams.join("&")
                // },
            })
            .then((response) => {
                set_total(response.data.total)
                setDatas(response.data.data);
            })
            .finally(() => {
                set_loading(false)
            })
    }
    useEffect(() => {
        if (extra_columns === null) {
            get_table_setting();
        } else {
            set_table_setting()
        }
    }, [extra_columns])
    const set_table_setting = () => {
        axios
            .post('/cramSchool/api/custom_table_setting', [
                {
                    table_name: 'admission_class',
                    table_data: [
                        ...extra_columns.map(map_item => ({
                            column_key: map_item.key,
                            column_name: map_item.key
                        }))
                    ]
                }
            ])
    }
    const get_table_setting = () => {
        axios
            .get('/cramSchool/api/custom_table_setting', {
                params: {
                    custom_table_setting_table_name: 'admission_class'
                }
            })
            .then(response => {
                set_extra_columns(response.data.map(map_item => ({
                    title: map_item.column_key,
                    key: map_item.column_key,
                    dataIndex: map_item.column_key,
                })))
            })
    }
    useEffect(() => {
        getData();
    }, []);
    const reload = () => {
        set_force_reload(prev => prev + 1)
    }
    useEffect(() => {
        reload()
    }, [search_date])
    const handleOnDelete = (value) => {
        axios
            .delete(`/cramSchool/api/admission_class`, {
                data: [{ class_id: value }]
            })
            .then((response) => {
                if (response.data.status != undefined) {
                    if (response.data.status == 'failure') {
                        setOpen(false);
                        messageApi.open({
                            type: 'error',
                            content: label_language.Common.children.delete_error[language],
                        });
                        reload();

                    } else {
                        setOpen(false);
                        messageApi.open({
                            type: 'success',
                            content: label_language.Common.children.delete_success[language],
                        });
                        reload();
                    }
                }
            })

    }
    const handleOnDeleteRow = () => {
        if (selectedRowKeys.length == 0) {
            messageApi.open({
                type: 'error',
                content: '請選擇資料',
            });
        } else {
            const deleterow = [];
            selectedRowKeys && selectedRowKeys.map((value, i) => {
                deleterow.push({ 'class_id': value })
            })
            axios
                .delete(`/cramSchool/api/admission_class`, {
                    data: deleterow
                })
                .then((response) => {
                    // console.log(response)
                    if (response.data.status != 'success') {
                        setOpen(false);
                        messageApi.open({
                            type: 'error',
                            content: label_language.Common.children.delete_error[language],
                        });
                        reload();
                    } else {
                        setOpen(false);
                        messageApi.open({
                            type: 'success',
                            content: label_language.Common.children.delete_success[language],
                        });
                        reload();
                    }
                })
        }
    }
    const handleOnAddRow = () => {
        setTitle(label_language.Common.children.add[language]);
        setColor('d65b77');
        setEdit(false);
        setOpen(true);
        setEditCard({});
        set_class_date([]);
        set_class_week([]);
    }

    const handleSearchDate = (date) => {
        set_search_date(date);
    }
    const handleEdit = (file_id) => {
        if (editcard.name == undefined || editcard.name == '') {
            messageApi.open({
                type: 'error',
                content: '修改失敗，請填寫姓名',
            });
        } else {
            axios
                .patch(`/cramSchool/api/admission_class`, [
                    {
                        ...editcard,
                        file_id,
                    }
                ])
                .then((response) => {
                    if (response.data.status == 'failure') {
                        setOpen(false);
                        messageApi.open({
                            type: 'error',
                            content: label_language.Common.children.edit_error[language],
                        });
                        reload();
                    } else {
                        setOpen(false);
                        messageApi.open({
                            type: 'success',
                            content: label_language.Common.children.edit_success[language],
                        });
                        reload();
                    }
                })
        }
    }
    const handleSubmit = () => {

        if (editcard.name == undefined || editcard.name == '' || editcard.lesson_class_data.length == 0 || editcard.teacher_id == '' || editcard.teacher_id == undefined) {
            messageApi.open({
                type: 'error',
                content: '新增失敗，請填寫必填欄位',
            });
        } else {
            axios
                .post(`/cramSchool/api/admission_class`, [
                    {
                        ...editcard,
                        content: ""
                    }
                ])
                .then((response) => {
                    if (response.data.status == 'failure') {
                        setOpen(false);
                        messageApi.open({
                            type: 'error',
                            content: label_language.Common.children.add_error[language],
                        });
                    } else {
                        setOpen(false);
                        messageApi.open({
                            type: 'success',
                            content: label_language.Common.children.add_success[language],
                        });
                        reload();
                    }
                })
        }
    }
    return (
        <>
            {contextHolder}
            <AdminClassSchedulingModal
                open={open}
                edit={edit}
                title={title}
                color={color}
                // setData={setData}
                // data={data}
                editcard={editcard}
                setEditCard={setEditCard}
                set_class_date={set_class_date}
                class_week={class_week}
                set_class_week={set_class_week}
                class_date={class_date}
                setOpen={setOpen}
                handleEdit={handleEdit}
                handleSubmit={handleSubmit}
            />
            <Row justify={'space-between'} style={{ paddingTop: '10px' }}>
                <Col span={24} >
                    <NewTable
                        total={total}
                        extra_columns={extra_columns}
                        set_extra_columns={set_extra_columns}
                        loading={loading}
                        page_name={'ClassScheduleList'}
                        force_reload={force_reload}
                        columns={default_column.concat(extra_columns || [])}
                        getData={getData}
                        datas={datas}//table資料
                        add_button_title={label_language.course_arrangement_management.children.AdminClassScheduling.children.add_lesson_schedule[language]}//新增按鈕上的名稱
                        handleOnAddRow={handleOnAddRow}//新增row 內容
                        rowkey={'class_id'}//key
                        setSelectedRowKeys={setSelectedRowKeys}
                        selectedRowKeys={selectedRowKeys}
                        handleOnDeleteRow={handleOnDeleteRow}//多筆刪除
                        searchdate={true}
                        rangepicker_title={'授課時間'}
                        handleSearchDate={handleSearchDate}//搜尋日期
                    ></NewTable>
                </Col>
            </Row>
        </>
    )
}
export default AdminClassScheduling;
